<script>
import FormModel from "@/views/Evaluation/EvaluationInterview/Components/FormModel.vue";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
        deleteAction: Boolean,
        getIt: Boolean,
    },
    components: {FormModel}
}
</script>

<template>
    <FormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        type="EVALUATION_PERFORMANCE"
        :get-it="getIt"
    />
</template>